import { ReactSVG } from "react-svg";
import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

// Дві колонки на десктопі: акордеони зліва, прогрес і новини справа
export const Wrapper = styled.div`
   display: grid;
   grid-template-columns: minmax(0, 1fr) 340px;
   grid-template-areas: "main side";
   align-items: start;
   gap: 24px;
   padding-bottom: 40px;
   max-width: 1120px;

   @media (max-width: 1280px) {
      grid-template-columns: minmax(0, 1fr);
      grid-template-areas: "side" "main";
   }
`

export const DropDownList = styled.ul`
   grid-area: main;
   display: flex;
   flex-direction: column;
   gap: 12px;
   width: 100%;
`

export const DropDownItem = styled.li`
   width: 100%;
   border-radius: ${radius.lg};
   background: ${colors.surface};
   border: 1px solid ${colors.line};
   box-shadow: ${shadow.card};
   overflow: hidden;
`

export const DropDownElWrapper = styled.div`
   width: 100%;
   padding: 0 18px 18px;
`

export const Video = styled.iframe`
   width: 100%;
   height: 300px;
   border: 0;
   border-radius: ${radius.md};

   @media (min-width: 768px) {
      height: 400px;
   }
`

export const LampIcon = styled(ReactSVG)`
   display: none;
`

export const RightPartWrapper = styled.div`
   grid-area: side;
   display: flex;
   flex-direction: column;
   gap: 16px;
   width: 100%;
`

// ---------- Блок вчителя «Не забудь зробити відмітку» ----------

export const LessonsWrapper = styled.section`
   display: flex;
   flex-direction: column;
   gap: 10px;
   padding: 20px;
   border-radius: ${radius.lg};
   background: ${colors.surface};
   border: 1px solid ${colors.line};
   box-shadow: ${shadow.card};
`

export const LessonsCard = LessonsWrapper;

export const BlockTitle = styled.h3`
   font-family: ${font.text};
   font-size: 17px;
   font-weight: 800;
   color: ${colors.ink};
   margin-bottom: 4px;
`

export const LessonItem = styled.div`
   display: flex;
   flex-direction: column;
   gap: 10px;
   padding: 14px;
   border-radius: ${radius.md};
   background: ${(props) => (props.isMarked ? colors.successSoft : colors.bg)};
   font-family: ${font.text};
   font-size: 14px;
   font-weight: 700;
   color: ${colors.success};
`

export const LessonHeader = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
`

export const StudentName = styled.div`
   flex: 1;
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 800;
   color: ${colors.ink};
`

export const Time = styled.div`
   padding: 4px 10px;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 13px;
   font-weight: 700;
   text-transform: capitalize;
   color: ${colors.brandDeep};
   background: ${colors.brandSoft};
`

export const Teacher = styled.div`
   font-family: ${font.text};
   font-size: 14px;
   color: ${colors.muted};
   cursor: pointer;
`

export const CallButton = styled.a`
   align-self: flex-start;
   padding: 9px 14px;
   border-radius: ${radius.sm};
   font-family: ${font.text};
   font-size: 14px;
   font-weight: 800;
   color: #FFFFFF;
   background: ${colors.brand};
   text-decoration: none;
   cursor: pointer;

   &:hover {
      background: ${colors.brandDeep};
   }
`

export const Loading = styled.div`
   font-family: ${font.text};
   font-size: 15px;
   color: ${colors.muted};
`

export const NoLessons = styled.div`
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 500;
   color: ${colors.muted};
`
